import { SET_SUBTYPE, SET_TYPE, CLEAR_RETAILER_DASHBOARDS } from '../actions/retailer-dashboards.actions';

const initialState = {
  type: '',
  subtype: 'summary',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_TYPE: {
      return { ...state, type: action.payload, subtype: 'summary' };
    }
    case SET_SUBTYPE: {
      return { ...state, subtype: action.payload };
    }
    case CLEAR_RETAILER_DASHBOARDS: {
      return initialState;
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/retailer-dashboards/reducers/retailer-dashboards.reducer.js